/* global Blockly */

import React from 'react';
import PropTypes from 'prop-types';
import MobiControlCore from '../../../v1/blocks/MobiControl/MobiControlCore';

const USER_DETAIL_OPTIONS = [
    ['user details', 'getUserDetails'],
    ['user RID', 'getUserReferenceId'],
    ['first name', 'getFirstName'],
    ['last name', 'getLastName'],
    ['email', 'getEmail'],
    ['group name', 'getGroupName'],
    ['Idp Type', 'getIdentityProviderType'],
    ['login method', 'getLoginMethod'],
    ['user name', 'getUserName']
];

function defineBlock(context) {
    const prop = { ...context };
    prop.tooltipText = 'Get the selected MobiControl user detail.';
    prop.responseText = 'user detail value';
    prop.responseBlockType = 'string_or_number_response';

    const blockInstance = MobiControlCore(prop);
    blockInstance.addFields = function () {
        this.appendDummyInput()
            .appendField('get MC user field')
            .appendField(new Blockly.FieldDropdown(USER_DETAIL_OPTIONS), 'DETAIL');
    };

    return blockInstance;
}

function defineGenerators() {
    return {
        JavaScript: function (block) {
            const methodName = block.getFieldValue('DETAIL');
            const coreResponseCode = block.getJavascriptCore();
            return `Snap.mcLockdown.user.${methodName}(${coreResponseCode});\n`;
        }
    };
}

const MobiControlGetUserDetail = function (props) {
    const name = 'snap_mobicontrol_getuserdetail';
    MobiControlGetUserDetail.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    const generators = defineGenerators();
    for (const language in generators) {
        Blockly[language][name] = generators[language];
    }

    return <block type={name}></block>;
};

MobiControlGetUserDetail.propTypes = {
    context: PropTypes.object
};

export default MobiControlGetUserDetail;
